var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button-group',{attrs:{"size":"sm"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name: 'Edit User', params: { id: _vm.rowData.id }}}},[_c('i',{staticClass:"fa fa-cogs",attrs:{"title":"Manage"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }